import React, { FC } from "react";

import moment from "moment";

import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ReplayIcon from "@mui/icons-material/Replay";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CardMui from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { styled, Box } from "@mui/system";
import Button from "@mui/material/Button";

const Card = styled(CardMui)(({ theme }) => ({
	margin: theme.spacing(1),
	marginBottom: 1,
	// },
}));

interface NavigazioneGiorniToolbarProps {
	titolo?: string;
	dataPresente?: boolean;
	data?: Date;
	setData: (data: Date) => void;
	refresh: () => void;
	Toolbar?: FC;
}

const NavigazioneGiorniToolbar = ({
	titolo,
	dataPresente = true,
	data,
	setData,
	refresh,
	Toolbar,

	...props
}: NavigazioneGiorniToolbarProps) => {
	// moment.locale("it");

	const cambiaGiorno = (avanti: Boolean) => {
		data &&
			(avanti
				? setData(new Date(data.setDate(data.getDate() + 1)))
				: setData(new Date(data.setDate(data.getDate() - 1))));
	};

	const [datePickerView, setDatePickerView] = React.useState<Boolean>(false);
	const changeData = (newValue: Date) => {
		setData(newValue);
	};

	return (
		<Card sx={{ p: 1 }}>
			<Grid container spacing={1}>
				<Grid item xs={12} sm={6} md={6} lg={3}>
					{/* <Stack
						direction="row"
						justifyContent="center"
						alignItems="center"
						// mr={2}
						marginX={{ xs: 1, md: 2 }}
						spacing={2}
					> */}
					<Typography variant="h5" sx={{ m: 1 }}>
						{titolo}
					</Typography>
				</Grid>{" "}
				<Grid item xs={12} sm={6} md={6} lg={5}>
					{dataPresente ? (
						<>
							<Typography
								variant="subtitle1"
								sx={{ display: { sm: "block", md: "none" } }}
							>
								<IconButton
									aria-label="GiornoPrecedente"
									onClick={() => {
										cambiaGiorno(false);
									}}
								>
									<ArrowBackIosIcon />
								</IconButton>

								{moment(data).format("DD/MM/YYYY")}
								<Button
									// sx={{ ml: 1, mr: 1 }}
									onClick={() => {
										setDatePickerView(!datePickerView);
									}}
								>
									<DateRangeIcon />
								</Button>
								<IconButton
									color="primary"
									aria-label="upload picture"
									component="span"
									onClick={refresh}
								>
									<ReplayIcon />
								</IconButton>
								<IconButton
									aria-label="GiornoSuccessivo"
									onClick={() => {
										cambiaGiorno(true);
									}}
								>
									<ArrowForwardIosIcon />
								</IconButton>
							</Typography>
							<Typography
								variant="h5"
								sx={{ display: { xs: "none", sm: "none", md: "block" } }}
							>
								<IconButton
									aria-label="GiornoPrecedente"
									onClick={() => {
										cambiaGiorno(false);
									}}
								>
									<ArrowBackIosIcon />
								</IconButton>
								{moment(data).format("dddd LL")}{" "}
								<Button
									sx={{ p: 2, ml: 2, mr: 2 }}
									onClick={() => {
										setDatePickerView(!datePickerView);
									}}
								>
									<DateRangeIcon />
								</Button>
								<IconButton
									color="primary"
									aria-label="upload picture"
									component="span"
									onClick={refresh}
								>
									<ReplayIcon />
								</IconButton>
								<IconButton
									aria-label="GiornoSuccessivo"
									onClick={() => {
										cambiaGiorno(true);
									}}
								>
									<ArrowForwardIosIcon />
								</IconButton>
							</Typography>
						</>
					) : (
						<IconButton
							color="primary"
							aria-label="upload picture"
							component="span"
							onClick={refresh}
						>
							<ReplayIcon />
						</IconButton>
					)}
					{datePickerView && (
						<StaticDatePicker
							displayStaticWrapperAs="desktop"
							openTo="day"
							value={data}
							onChange={(newValue) => {
								newValue && changeData(new Date(newValue));
							}}
							renderInput={(params) => <TextField {...params} />}
						/>
					)}
				</Grid>
				<Grid item xs={12} sm={6} md={6} lg={4}>
					{Toolbar && <Toolbar />}
				</Grid>
			</Grid>
		</Card>
	);
};

export default NavigazioneGiorniToolbar;
